var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-chat-file-message',{attrs:{"fileName":_vm.doc.fileName,"fileSize":_vm.formattedFileSize,"downloadUrl":_vm.downloadUrl,"isImage":_vm.isImage},on:{"click":_vm.onClickDownload}})}
var staticRenderFns = []

export { render, staticRenderFns }